module.exports = __webpack_public_path__ + "static/assets/9c86f22b75862bfc6b8165fd0df5639e.png";